
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/generator",
      function () {
        return require("private-next-pages/generator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/generator"])
      });
    }
  